var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"picker-group"},[_c('ScrollPicker',{attrs:{"options":_vm.hours},model:{value:(_vm.hour),callback:function ($$v) {_vm.hour=$$v},expression:"hour"}}),_c('ScrollPicker',{attrs:{"options":_vm.minutes},model:{value:(_vm.minute),callback:function ($$v) {_vm.minute=$$v},expression:"minute"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }